<template>
<div>
    <ValidationObserver v-slot="{ handleSubmit, reset }">
      <b-form ref="productForm" @submit.prevent="handleSubmit(performAction)" @reset.prevent="reset">
        <div class="d-flex flex-md-row flex-column mb-3">
          <div class="card">
            <div class="card-body"  style="max-width: 620px"> 
              <div>
                <b-row class="mb-5">
                  <label v-if="action == 'add' && !agentTransactionLogsModule.access.create" class="form-label medium fw-bold text-danger">Note: Your access is limited. You cannot add an Agent.</label>
                  <label v-if="action == 'disable' && !agentTransactionLogsModule.access.update" class="form-label medium fw-bold text-danger">Note: Your access is limited. You cannot disable an Agent.</label>
                  <b-col sm="12" class="mb-3">
                    <label class="form-label small fw-bold"
                      >Action*</label
                    >

                    <validation-provider
                      name="agent action"
                      rules="required"
                      v-slot="{ errors, ariaMsg }"
                    >
                      <multiselect
                        v-model="selectedAction"
                        :options="actionOptions"
                        track-by="value"
                        label="text"
                        name="action"
                        select-label="Click to select"
                        deselect-label="Click to remove"
                        placeholder="Choose an option"
                        @input="onChange"
                        :allow-empty="true"
                        :preselect-first="false"
                        :class="{
                          invalid: errors[0],
                        }"
                      ></multiselect>
                      <b-form-invalid-feedback v-bind="ariaMsg">
                        {{ errors[0] }}
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </b-col>

                  <b-col sm="12" class="mb-3" v-if="action != 'add'">
                    <label class="form-label small fw-bold">Search</label>
                      <multiselect
                        ref="searchBox"
                        class="search-box"
                        v-model="selectedAgent"
                        track-by="id"
                        label="fullname"
                        name="search agent"
                        select-label="Select"
                        deselect-label="Remove"
                        placeholder="Type to search agent name or code"
                        @search-change="search"
                        @input="loadAgent"
                        :clear-on-select="false" 
                        :preserve-search="true"
                        :allow-empty="true"
                        :disabled="formStatus.searchDisable"
                        :internal-search="false"
                        :preselect-first="false"
                        :options="agents"
                      >
                        <template slot="caret">
                          <div class="caret d-flex align-items-center">
                            <i class="bx bx-search bx-fw"></i>
                          </div>
                        </template>
                        <template slot="beforeList">
                          <b-row class="p-2">
                            <b-col class="font-bold">Agent Code</b-col>
                            <b-col class="font-bold">Agent Name</b-col>
                          </b-row>
                        </template>
                        <template slot="option" slot-scope="props">
                          <b-row>
                            <b-col>{{props.option.agent_code}}</b-col>
                            <b-col>{{props.option.fullname}}</b-col>
                          </b-row>
                        </template>
                      </multiselect>
                  </b-col>

                  <b-col sm="12" class="mb-3">
                    <label class="form-label small fw-bold"
                      >Name*</label
                    >
                    <validation-provider
                      name="agent name"
                      rules="required"
                      v-slot="validationContext"
                      :disabled="formStatus.nameDisable"
                    >
                      <b-form-input
                        v-model="agent.fullname"
                        :state="getValidationState(validationContext)"
                        type="text"
                        :disabled="formStatus.nameDisable"
                        class="form-control"
                      />
                      <b-form-invalid-feedback>
                        {{ validationContext.errors[0] }}
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </b-col>

                  <b-col sm="12" class="mb-3">
                    <label class="form-label small fw-bold"
                      >Agent Code*</label
                    >
                    <validation-provider
                      name="agent code"
                      rules="required|exist"
                      mode="lazy"
                      v-slot="validationContext"
                      :disabled="formStatus.codeDisable"
                    >
                      <b-form-input
                        v-model="agent.agent_code"
                        :state="getValidationState(validationContext)"
                        type="text"
                        :disabled="formStatus.codeDisable"
                        class="form-control"
                      />
                      <b-form-invalid-feedback>
                        {{ validationContext.errors[0] }}
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </b-col>
                </b-row>

                <b-row class="mb-3">
                  <b-col sm="2"></b-col>
                  <b-col sm="5">
                    <b-btn @click="goBack" class="w-100" variant="light">Close</b-btn>
                  </b-col>
                  <b-col sm="5">
                    <b-btn :disabled="action == 'add' ? !agentTransactionLogsModule.access.create : !agentTransactionLogsModule.access.update" class="w-100" variant="primary" type="submit">Confirm</b-btn>
                  </b-col>
                </b-row>
              </div>
            </div>
          </div>
        </div>
      </b-form>
    </ValidationObserver>
</div>
</template>

<script>
import {
  agentComputed,
  layoutMethods,
  agentMethods,
  erpUserRolesMethods
} from "@/state/helpers";
import Multiselect from "vue-multiselect";
import Swal from "sweetalert2";
import { extend } from 'vee-validate';
import { getModuleAccess } from '@/router/helper.js'

export default {
  data(){
    return {
      action: '',
      selectedAgent: null,
      agent: {
        id: null,
        fullname: null,
        agent_code: null
      },
      formStatus: {
        searchDisable: true,
        nameDisable: true,
        codeDisable: true
      },
      actionOptions: [
        {text: 'Add an agent', value: 'add'},
        {text: 'Disable an agent', value: 'disable'}
      ],
      agentTransactionLogsModule: {
				access: {
					create: true,
          update: true
				}
			}
    }
  },
  computed:{
    ...agentComputed,
    selectedAction: {
      get() {
        var action = null;
        this.actionOptions.forEach((a) => {
          if (a.value == this.action) {
            action = a;
          }
        });
        return action;
      },
      set(action) {
        if (action) {
          this.action = action.value;
        } else {
          this.action = null;
        }
      },
    },
  },
  components:{
    Multiselect
  },
  methods: {
    ...layoutMethods,
    ...agentMethods,
    ...erpUserRolesMethods,
    getValidationState({ dirty, validated, valid = null }) {
      return dirty && validated ? valid : null;
    },
    goBack(){
      this.$router.push('dashboard#agent-menu');
    },
    onChange(){
      this.agent = {
        id: null,
        agent_code: null,
        fullname: null
      }
      this.selectedAgent = null;

      if(this.action == 'add'){
        this.formStatus.searchDisable = true;
        this.formStatus.nameDisable = false;
        this.formStatus.codeDisable =  false;
      } else if(this.action == 'disable') {
        this.formStatus.searchDisable = false;
        this.formStatus.nameDisable = true;
        this.formStatus.codeDisable =  true;
        this.search('');
      } else {
        this.formStatus.searchDisable = true;
        this.formStatus.nameDisable = true;
        this.formStatus.codeDisable =  true;
      }

      console.log('action value: ', this.action)
    },
    performAction(){
      var _this = this;

      if(this.action == 'add'){
        var agentDetails = {
          fullname: this.agent.fullname,
          agent_code: this.agent.agent_code
        };
        
        Swal.fire({
          title: "Add Agent?",
          text: `Are you sure you want to proceed?`,
          icon: "question",
          showCancelButton: true,
          cancelButtonText: "No",
          confirmButtonColor: "#c4297c",
          cancelButtonColor: "#804997",
          confirmButtonText: "Yes",
        }).then((result) => {
          if (result.value) {
            this.createAgent(agentDetails)
              .then(() => {
                Swal.fire(
                  "Successful!",
                  `${agentDetails.fullname} has been added.`,
                  "success"
                ).then(() => {
                  _this.$router.push('dashboard#agent-menu');
                });
              })
              .catch(() => {
                Swal.fire(
                  "Failed!",
                  `${agentDetails.fullname} has not been added.`,
                  "error"
                ).then(() => {
                  _this.$router.push('dashboard#agent-menu');
                });
              });
          }
        });
      } else if(this.action == 'disable') {
        var agentId = this.agent.id;

        if(!agentId){
          Swal.fire(
            "Warning!",
            `Please select an agent to disabled.`,
            "warning"
          );
          return;
        }

        Swal.fire({
          title: "Disable Agent?",
          text: `Are you sure you want to proceed?`,
          icon: "question",
          showCancelButton: true,
          cancelButtonText: "No",
          confirmButtonColor: "#c4297c",
          cancelButtonColor: "#804997",
          confirmButtonText: "Yes",
        }).then((result) => {
          if (result.value) {
            this.disableAgent(agentId)
              .then(() => {
                Swal.fire(
                  "Successful!",
                  `${this.agent.fullname} has been disabled.`,
                  "success"
                ).then(() => {
                  _this.$router.push('dashboard#agent-menu');
                });

                
              })
              .catch(() => {
                Swal.fire(
                  "Failed!",
                  `${this.agent.fullname} has not been disabled.`,
                  "error"
                ).then(() => {
                  _this.$router.push('dashboard#agent-menu');
                });
              });
          }
        });
      }
    },
    search(query){
      var params = { keyword: query };
      if(!query){
        params.rows = 10;
      }

      this.searchAgent(params)
        .then(() => {})
        .catch(() => {});
    },
    loadAgent(){
      if(this.selectedAgent){
        this.agent = this.selectedAgent;
      } else {
        this.agent = {
          id: null,
          agent_code: null,
          fullname: null
        }
      }
    }
  },
  async mounted(){
    var _this = this;
    extend('exist', {
      message: 'Agent code already taken',
      validate(value){
        return _this.isExist(value).then(res => {
          return !res.message.isExist;
        });
      }
    });

    this.changeTitle({ title: `Add/Disable Agent` });
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: 'Peddlr', to: { name: 'Home' } },
        { text: 'Add/Disable Agent', to: { name: 'Agent' } }
      ]
    });

    // get the module access for checking if user has create, read, update, and/or delete access
    await getModuleAccess('Reports', 'Agent Transaction Logs')
        .then((access) => this.agentTransactionLogsModule.access = access);
    
  }
}
</script>

<style>
.agent-body {
  max-width: 620px
}

.font-bold {
  font-weight: bold;
}

.multiselect.invalid .multiselect__tags {
  border-color: #f34e4e;
  padding-right: calc(1.5em + 0.94rem);
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23f34e4e'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23f34e4e' stroke='none'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.235rem) center;
  background-size: calc(0.75em + 0.47rem) calc(0.75em + 0.47rem);
}

.invalid ~ .invalid-feedback {
  display: block;
}

.multiselect__option--highlight,
.multiselect__option--highlight::after {
  background: #f8f9fa;
  color: #495057;
}

.multiselect__tag {
  background-color: #e73092 !important;
  border-color: #e73092 !important;
  margin-bottom: 0 !important;
  font-weight: 400 !important;
}

.multiselect__tag-icon:after {
  color: #fff !important;
}

.multiselect__tag-icon:focus,
.multiselect__tag-icon:hover {
  background-color: #e73092 !important;
}

.search-box .caret {
  position: absolute;
  width: 40px;
  height: 41px;
  right: 1px;
  top: 1px;
  padding: 4px 8px;
  text-align: center;
  transition: transform .2s ease;
  background-color: #e73092 !important;
  color: #FFF;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}
</style>